import { round2 } from '~/apps/smartsend/lib/parcels/round';

/**
 * Splits `value` across `quantity` pieces so the pieces always sum back to `value` exactly: every piece
 * takes the floored 2dp share and the FIRST one additionally absorbs the rounding remainder.
 *
 * `valueForFirstItem` is rounded because `valuePerItem + valueLeftOver` is dust-prone even though both
 * operands are already 2dp - QuantityValueSummary(0.86, 4) gave 0.21 + 0.02 = 0.22999999999999998, which
 * reached a parcel's Weight field through SplitConsignmentWeight and rendered as "0.229999999..." for a
 * tester. Rounding here cannot shift the value, because the exact sum of two 2dp decimals is itself 2dp;
 * it only picks the canonical double for that decimal. Callers that already round at their own boundary
 * (see allocate.ts) are unaffected.
 */
export function QuantityValueSummary(value: number, quantity: number) {
  const valueNumber = Number(value);
  const quantityNumber = Number(quantity);
  const valuePerItem = Math.floor((valueNumber / quantityNumber) * 100) / 100;
  const totalValueWithoutLeftOver = valuePerItem * quantityNumber;
  const valueLeftOver = Math.round((valueNumber - totalValueWithoutLeftOver) * 100) / 100;
  return {
    valuePerItem: valuePerItem,
    valueLeftOver: valueLeftOver,
    valueForFirstItem: round2(valuePerItem + valueLeftOver),
    valueForOtherItems: valuePerItem
  };
}
